import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from 'app/_guards/auth.guard';
import { RastreamentoComponent } from './rastreamento.component';

const rastreamentoRoutes: Routes = [
    { path: '', component: RastreamentoComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(rastreamentoRoutes)],
    exports: [RouterModule]
})
export class RastreamentoRoutingModule {}